import styled from "styled-components";

export const DemoPageStyle=styled.div`



.main {
  padding: 20px; /* add some padding */
  width:100%;
  display:flex;
  flex-wrap:wrap;
  justify-content:center;
}

.graphbar{
  
  align-self:center;
  margin-top:50px;
  display:flex;
  justify-content:center;
}

.noDemoUser{
    font-size:1rem;
    font-family:  "Decimal A", "Decimal B", Avenir, "Helvetica Neue", Helvetica, "Arial Narrow", sans-serif;
    text-align:center;
    color:#f28809;
}

`